<template>
    <div :class="classes + ' cu-input tw-w-full ' + (disabled ? 'bordered-input-disabled tw-bg-semilight-grey tw-rounded-lg tw-pointer-events-none' : '')">
        <div :class="'tw-flex tw-flex-row tw-w-full tw-box-border '  + (fixedHeight ? 'tw-h-10' : '')">
            <div id="cu-input-border-left"
                 class="tw-pr-3 tw-border-t tw-border-b tw-border-l tw-rounded-l-lg tw-border-border-input"></div>
            <div class="tw-w-full">
                <div class="tw-flex tw-flex-row tw-w-full" style="height: 18px;">
                    <div class="tw--mt-2 tw-mx-1 tw-w-auto tw-text-black tw-text-[10px] tw-leading-4">
                        <slot name="label"></slot>
                    </div>
                    <div id="cu-input-border-top" class="tw-w-full tw-border-t tw-border-border-input"></div>
                </div>
                <div :class="'tw-relative tw--mt-2 tw-mb-1 tw-text-black'" :style="fixedHeight ? 'height: 25px;' : ''">
                    <slot name="input"></slot>
                    <div class="calendar-icon tw-hidden tw-absolute tw-top-0 tw-right-0  tw-box-border tw-w-5 tw-h-5 tw-p-2 tw-bg-white tw-pointer-events-none">
                        <div class="tw-w-3 tw-h-3 tw--mt-1">
                            <svg xmlns="http://www.w3.org/2000/svg" class="tw-w-full tw-h-full tw-text-black"
                                 viewBox="0 0 12 11.294">
                                <path d="M9.882.706V0H7.765v.706h-3.53V0H2.118v.706H0v10.588h12V.706zm-1.412 0h.706v1.412h-.705zm-5.647 0h.706v1.412h-.705zm8.471 9.882H.706v-6.3h10.588zm-10.588-7V1.412h1.412v1.412h2.117V1.412h3.53v1.412h2.117V1.412h1.412v2.173z"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div id="cu-input-border-bottom" class="tw-border-b tw-border-border-input"></div>
            </div>
            <div id="cu-input-border-right"
                 class="tw-w-3 tw-border-t tw-border-r tw-border-b tw-rounded-r-lg tw-border-border-input"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BorderedInput",

        props: {
            classes: {
                required: false,
                type: String,
                default: '',
            },
            type: {
                required: false,
                type: String,
                default: 'textfield',
            },
            disabled: {
                required: false,
                type: Boolean,
                default: false,
            }
        },

        computed: {
            fixedHeight() {
                return ['textarea', 'multiselect'].indexOf(this.type) === -1;
            }
        },
    }
</script>
